// Arrow Animation
(function (cjs, an) {

	var p; // shortcut to reference prototypes
	var lib={};var ss={};var img={};
	lib.ssMetadata = [];


	// symbols:



	(lib.Tween8 = function(mode,startPosition,loop) {
		this.initialize(mode,startPosition,loop,{});

		// Layer 1
		this.shape = new cjs.Shape();
		this.shape.graphics.f("#FFFFFF").s().p("AipCpQhGhGAAhjQAAhiBGhHQBHhGBiAAQBjAABGBGQBHBHAABiQAABjhHBGQhGBHhjAAQhiAAhHhHg");

		this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(-24,-24,48,48);


	// stage content:
	(lib.animationfirefox_HTML5Canvas = function(mode,startPosition,loop) {
		this.initialize(mode,startPosition,loop,{});

		// Layer 4
		this.shape = new cjs.Shape();
		this.shape.graphics.f().s("#FF7800").ss(2,2,1).p("AAJgBIgJAIIgIgI");
		this.shape.setTransform(28,19.3);

		this.shape_1 = new cjs.Shape();
		this.shape_1.graphics.f().s("#FF7800").ss(2,2,1).p("AAAgNIAAAbIgcgbAAdgNIgdAb");
		this.shape_1.setTransform(28,20.6);

		this.shape_2 = new cjs.Shape();
		this.shape_2.graphics.f().s("#FF7800").ss(2,2,1).p("AAAAYIgwgvAAAAYIAxgvAAAgXIAAAv");
		this.shape_2.setTransform(28,21.6);

		this.shape_3 = new cjs.Shape();
		this.shape_3.graphics.f().s("#FF7800").ss(2,2,1).p("AAAgTIgwgxAAAgTIAxgxAAAhYIAABFAAJBZIgRAA");
		this.shape_3.setTransform(28,28);

		this.shape_4 = new cjs.Shape();
		this.shape_4.graphics.f().s("#FF7800").ss(2,2,1).p("AAAAAIgwgwAAAAAIAxgwAAAhYIAABYAATBZIglAA");
		this.shape_4.setTransform(28,28);

		this.shape_5 = new cjs.Shape();
		this.shape_5.graphics.f().s("#FF7800").ss(2,2,1).p("AAAAUIgwgwAAAAUIAxgwAAAhYIAABsAAnBZIhNAA");
		this.shape_5.setTransform(28,28);

		this.shape_6 = new cjs.Shape();
		this.shape_6.graphics.f().s("#FF7800").ss(2,2,1).p("AA8BZIh2AAAAAAeIgwgwAAAAeIAxgwAAAhYIAAB2");
		this.shape_6.setTransform(28,28);

		this.shape_7 = new cjs.Shape();
		this.shape_7.graphics.f().s("#FF7800").ss(2,2,1).p("AAAAoIAxgwAAAhYIAACAIgwgwABQBZIifAA");
		this.shape_7.setTransform(28,28);

		this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape}]},9).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[{t:this.shape_5}]},1).to({state:[{t:this.shape_6}]},1).to({state:[{t:this.shape_7}]},1).wait(14));

		// Layer 3
		this.shape_8 = new cjs.Shape();
		this.shape_8.graphics.f().s("#FF7800").ss(2,2,1).p("ABQBZIifAAAAAAoIgwgwAAAAoIAxgwAAAhYIAACA");
		this.shape_8.setTransform(28,28);

		this.shape_9 = new cjs.Shape();
		this.shape_9.graphics.f().s("#FF7800").ss(2,2,1).p("ABQBZIifAAAAAAtIgwgwAAAAtIAxgwAAAhYIAACF");
		this.shape_9.setTransform(28,28);

		this.shape_10 = new cjs.Shape();
		this.shape_10.graphics.f().s("#FF7800").ss(2,2,1).p("ABQBZIifAAAAAA8IgwgxAAAA8IAxgxAAAhYIAACU");
		this.shape_10.setTransform(28,28);

		this.shape_11 = new cjs.Shape();
		this.shape_11.graphics.f().s("#FF7800").ss(2,2,1).p("ABQBZIifAAAAABQIgwgxAAABQIAxgxAAAhYIAACo");
		this.shape_11.setTransform(28,28);

		this.shape_12 = new cjs.Shape();
		this.shape_12.graphics.f().s("#FF7800").ss(2,2,1).p("AgKBNIgmgmAgKBNIhFAAAALBNIAmgmAAAhQIAACdIgKAAAALBNIgLAAABQBNIhFAA");
		this.shape_12.setTransform(28,29.2);

		this.shape_13 = new cjs.Shape();
		this.shape_13.graphics.f().s("#FF7800").ss(2,2,1).p("AgeBDIgSgSAgeBDIgxAAAAfBDIASgSAAAhGIAACJIgeAAAAfBDIgfAAABQBDIgxAA");
		this.shape_13.setTransform(28,30.2);

		this.shape_14 = new cjs.Shape();
		this.shape_14.graphics.f().s("#FF7800").ss(2,2,1).p("AAAA7IhPAAAAAg6IAAB1ABQA7IhQAA");
		this.shape_14.setTransform(28,31);

		this.shape_15 = new cjs.Shape();
		this.shape_15.graphics.f().s("#FF7800").ss(2,2,1).p("AAAAxIg6AAAAAgwIAABhAA8AxIg8AA");
		this.shape_15.setTransform(28,32);

		this.shape_16 = new cjs.Shape();
		this.shape_16.graphics.f().s("#FF7800").ss(2,2,1).p("AAAgmIAABNIgmAAAAnAnIgnAA");
		this.shape_16.setTransform(28,33);

		this.shape_17 = new cjs.Shape();
		this.shape_17.graphics.f().s("#FF7800").ss(2,2,1).p("AAAgcIAAA5IgSAAAATAdIgTAA");
		this.shape_17.setTransform(28,34);

		this.shape_18 = new cjs.Shape();
		this.shape_18.graphics.f().s("#FF7800").ss(2,2,1).p("AAAgSIAAAl");
		this.shape_18.setTransform(28,35);

		this.shape_19 = new cjs.Shape();
		this.shape_19.graphics.f().s("#FF7800").ss(2,2,1).p("AAAgIIAAAR");
		this.shape_19.setTransform(28,36);

		this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_8}]}).to({state:[{t:this.shape_9}]},1).to({state:[{t:this.shape_10}]},1).to({state:[{t:this.shape_11}]},1).to({state:[{t:this.shape_12}]},1).to({state:[{t:this.shape_13}]},1).to({state:[{t:this.shape_14}]},1).to({state:[{t:this.shape_15}]},1).to({state:[{t:this.shape_16}]},1).to({state:[{t:this.shape_17}]},1).to({state:[{t:this.shape_18}]},1).to({state:[{t:this.shape_19}]},1).to({state:[]},1).wait(18));

		// Layer 5
		this.instance = new lib.Tween8("synched",0);
		this.instance.parent = this;
		this.instance.setTransform(28,28);

		this.timeline.addTween(cjs.Tween.get(this.instance).to({scaleX:1.01,scaleY:1.01},2).to({scaleX:1.05,scaleY:1.05},2).to({scaleX:1.16,scaleY:1.16},4).to({scaleX:1.04,scaleY:1.04},4).to({scaleX:1.01,scaleY:1.01},2).to({scaleX:1,scaleY:1},2).wait(14));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(32,32,48,48);
	// library properties:
	lib.properties = {
		id: '7B96A2C974600840999FF72FD932BD84',
		width: 56,
		height: 56,
		fps: 25,
		color: "#242C41",
		opacity: 1.00,
		manifest: [],
		preloads: []
	};



	// bootstrap callback support:

	(lib.Stage = function(canvas) {
		createjs.Stage.call(this, canvas);
	}).prototype = p = new createjs.Stage();

	p.setAutoPlay = function(autoPlay) {
		this.tickEnabled = autoPlay;
	}
	p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
	p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
	p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
	p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

	p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

	an.bootcompsLoaded = an.bootcompsLoaded || [];
	if(!an.bootstrapListeners) {
		an.bootstrapListeners=[];
	}

	an.bootstrapCallback=function(fnCallback) {
		an.bootstrapListeners.push(fnCallback);
		if(an.bootcompsLoaded.length > 0) {
			for(var i=0; i<an.bootcompsLoaded.length; ++i) {
				fnCallback(an.bootcompsLoaded[i]);
			}
		}
	};

	an.compositions = an.compositions || {};
	an.compositions['7B96A2C974600840999FF72FD932BD84'] = {
		getStage: function() { return exportRoot.getStage(); },
		getLibrary: function() { return lib; },
		getSpriteSheet: function() { return ss; },
		getImages: function() { return img; }
	};

	an.compositionLoaded = function(id) {
		an.bootcompsLoaded.push(id);
		for(var j=0; j<an.bootstrapListeners.length; j++) {
			an.bootstrapListeners[j](id);
		}
	}

	an.getComposition = function(id) {
		return an.compositions[id];
	}; 
})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
var createjs, AdobeAn;

// Init animation
(function() {
	var canvas, stage, exportRoot, anim_container, dom_overlay_container, fnStartAnimation;

	function init() {
		canvas = document.getElementById("canvas");
		anim_container = document.getElementById("animation_container");
		dom_overlay_container = document.getElementById("dom_overlay_container");
		var comp=AdobeAn.getComposition("7B96A2C974600840999FF72FD932BD84");
		var lib=comp.getLibrary();
		handleComplete({},comp);
	}
	function handleComplete(evt,comp) {
		//This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
		var lib=comp.getLibrary();
		var ss=comp.getSpriteSheet();
		exportRoot = new lib.animationfirefox_HTML5Canvas();
		stage = new lib.Stage(canvas);
		//Registers the "tick" event listener.
		fnStartAnimation = function() {
			stage.addChild(exportRoot);
			createjs.Ticker.setFPS(lib.properties.fps);
			createjs.Ticker.addEventListener("tick", stage);
		}
		//Code to support hidpi screens and responsive scaling.
		function makeResponsive(isResp, respDim, isScale, scaleType) {
			var lastW, lastH, lastS=1;
			window.addEventListener('resize', resizeCanvas);
			resizeCanvas();
			function resizeCanvas() {
				var w = lib.properties.width, h = lib.properties.height;
				var iw = window.innerWidth, ih=window.innerHeight;
				var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;
				if(isResp) {
					if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {
						sRatio = lastS;
					}
					else if(!isScale) {
						if(iw<w || ih<h)
							sRatio = Math.min(xRatio, yRatio);
					}
					else if(scaleType==1) {
						sRatio = Math.min(xRatio, yRatio);
					}
					else if(scaleType==2) {
						sRatio = Math.max(xRatio, yRatio);
					}
				}
				canvas.width = w*pRatio*sRatio;
				canvas.height = h*pRatio*sRatio;
				canvas.style.width = dom_overlay_container.style.width = anim_container.style.width =  w*sRatio+'px';
				canvas.style.height = anim_container.style.height = dom_overlay_container.style.height = h*sRatio+'px';
				stage.scaleX = pRatio*sRatio;
				stage.scaleY = pRatio*sRatio;
				lastW = iw; lastH = ih; lastS = sRatio;
				stage.tickOnUpdate = false;
				stage.update();
				stage.tickOnUpdate = true;
			}
		}
		makeResponsive(false,'both',false,1);
		AdobeAn.compositionLoaded(lib.properties.id);
		fnStartAnimation();
	}

	if (document.getElementById("canvas")) {
		init();
	}
})();
